import { sleep } from '@/utils'
import useStore from '@/stores/defaultStore'
import { v4 as uuidv4 } from 'uuid'
import pkg from '../package.json'
import { useRuntimeConfig } from '#imports'
import md5 from '@/utils/md5'

export let initTimestamp = NaN
let loading = false

// 根据服务器时间戳算出打开页面时的时间戳
export async function calcInitTime() {
  // 别的接口已经请求了时间戳接口，等着就行，不用重复请求
  while (loading) {
    await sleep(300)
  }
  if (initTimestamp) {
    return
  }
  loading = true
  const store = useStore()
  !store.deviceId && (await store.setDeviceId())
  const env = useRuntimeConfig()
  const headers: HeadersInit = {
    time: '' + Date.now(),
    reqId: uuidv4(),
    os: 'H5',
    deviceId: store.deviceId,
    deviceType: isMobile() ? 'mobile' : 'desktop',
    deviceVersion: isMobile() ? 'mobile' : 'desktop',
    appVersion: pkg.version.split('.').slice(0, 3).join('.'),
    keyVersion: env.public.secretKey.split(',')[0],
    from: '1'
  }
  headers.sign = reqSign({ method: 'get', headers })
  try {
    const raw = await fetch(env.public.proxyTarget + '/api/system/currentTimestamp', { method: 'get', headers })
    const res = await raw.json()
    initTimestamp = res.data - Math.floor(performance.now())
  } finally {
    loading = false
  }
}

const utf8Length = (str: string) => {
  let totalLength = 0
  for (let i = 0; i < str.length; i++) {
    const codePoint = str.codePointAt(i)
    if (codePoint === undefined) continue
    if (codePoint < 0x0080) {
      totalLength += 1
    } else if (codePoint < 0x07ff) {
      totalLength += 2
    } else if (codePoint < 0xffff) {
      totalLength += 3
      if (codePoint >= 0xd800 && codePoint <= 0xdbff) i++
    } else {
      totalLength += 4
      i++
    }
  }
  return totalLength
}

const sortedKeys = (idObject: Object) => {
  return Object.keys(idObject).sort((a, b) => {
    const length = Math.min(a.length, b.length)
    for (let i = 0; i < length; i++) {
      const charA = a.charAt(i).toLowerCase()
      const charB = b.charAt(i).toLowerCase()
      if (charA !== charB) {
        return charA.localeCompare(charB)
      }
    }
    return a.length - b.length
  })
}

function processItems(obj: any, keys: string[]) {
  let target = ''
  keys.forEach((item) => (target += obj[item]?.toString() || ''))
  return target
}

export const reqSign = (config: { method: string; headers: any; params?: any; data?: any }) => {
  const env = useRuntimeConfig()
  let [keyVersion, shift, ...charCodes] = env.public.secretKey.split(',')
  charCodes = charCodes.map((hex) => '' + (parseInt(hex, 16) - Number(shift)))
  let secretKey = ''
  for (const charCode of charCodes) {
    secretKey += String.fromCharCode(+charCode)
  }
  const { method, headers, params, data } = config
  let H = ''
  let Q = ''
  let B = ''
  const headersObj = {
    reqId: headers.reqId,
    os: headers.os ?? '',
    deviceId: headers.deviceId ?? '',
    deviceType: headers?.deviceType ?? '',
    deviceVersion: headers?.deviceVersion ?? '',
    appVersion: headers?.appVersion ?? '',
    time: headers?.time ?? '',
    keyVersion,
    from: headers?.from ?? ''
  }

  const headerKeys = sortedKeys(headersObj)
  H = processItems(headersObj, headerKeys)
  if (params) {
    const paramKeys = sortedKeys(params)
    Q = processItems(params, paramKeys)
  }
  if (method.toLowerCase() === 'get') {
    return md5(H + Q + secretKey)
  }
  const requestData = data || {}
  const dataKeys = sortedKeys(requestData)
  dataKeys.forEach((item) => {
    const value = JSON.parse(JSON.stringify(requestData[item] || ''))
    if (value === null || value === undefined) {
      B += ''
    } else if (typeof value === 'object') {
      B += Array.isArray(value) ? `[${value.length}]` : `{${Object.keys(value).length}}`
    } else {
      B += utf8Length(value) < 128 ? value : value.substring(value)
    }
  })
  return md5(H + Q + B + secretKey)
}
